var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 18,
    viewBox: "0 0 22.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-slash",
    "data-name": "Icon awesome-eye-slash",
    d: "M11.25,14.063a5.044,5.044,0,0,1-5.024-4.68L2.538,6.533A11.717,11.717,0,0,0,1.247,8.487a1.137,1.137,0,0,0,0,1.026,11.276,11.276,0,0,0,10,6.237,10.92,10.92,0,0,0,2.738-.368l-1.824-1.412a5.067,5.067,0,0,1-.914.092Zm11.033,2.043-3.887-3a11.646,11.646,0,0,0,2.856-3.588,1.137,1.137,0,0,0,0-1.026,11.276,11.276,0,0,0-10-6.237A10.833,10.833,0,0,0,6.071,3.575L1.6.118a.563.563,0,0,0-.79.1l-.69.888a.562.562,0,0,0,.1.789L20.9,17.882a.563.563,0,0,0,.79-.1l.69-.888a.563.563,0,0,0-.1-.789Zm-6.459-4.992-1.382-1.068A3.331,3.331,0,0,0,10.36,5.758a1.675,1.675,0,0,1,.327.992,1.64,1.64,0,0,1-.054.352l-2.588-2a5,5,0,0,1,3.2-1.164A5.06,5.06,0,0,1,16.313,9a4.942,4.942,0,0,1-.489,2.113Z",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.035a19268b0393e38baf4321f328b739.svg";
export { ForwardRef as ReactComponent };